module.exports = __webpack_public_path__ + "static/media/back_icon.2765fa64.svg";